import { hasActiveCapture } from "./buildings";
import { coordEq, getTile } from "./grid";
import type { Coord, GameState, Unit } from "./types";

export function wouldLeavingTileResetCapture({
  state,
  unit,
  destination,
}: {
  state: GameState;
  unit: Unit;
  destination: Coord;
}): boolean {
  if (coordEq(unit.pos, destination)) return false;
  return hasActiveCapture(getTile(state, unit.pos));
}
